import { render, staticRenderFns } from "./CategoryToFile.vue?vue&type=template&id=796e3456&scoped=true"
import script from "./CategoryToFile.vue?vue&type=script&lang=js"
export * from "./CategoryToFile.vue?vue&type=script&lang=js"
import style0 from "./CategoryToFile.vue?vue&type=style&index=0&id=796e3456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796e3456",
  null
  
)

export default component.exports